import React from 'react';
import * as Ons from 'react-onsenui';
import { getActionButtonPosition, reload } from '../../util';
import { translate as _, getLanguages } from '../../util/i18n';

class UserSettings extends React.Component {

    #languages;

    constructor( props ) {

        super( props );

        this.state = {

            saving:       false,
            userSettings: this.props.userSettings

        };

        this.handleActionButtonPositionChange = this.handleActionButtonPositionChange.bind( this );
        this.handleAppearanceModeChange       = this.handleAppearanceModeChange.bind( this );
        this.handleLanguageChange             = this.handleLanguageChange.bind( this );
        this.handleSaveUserSettings           = this.handleSaveUserSettings.bind( this );

        this.#languages = getLanguages();

    }

    handleActionButtonPositionChange( e ) {

        // e.index is always -1 on Android! Onsen bug?
        // this.setUserSetting( 'actionButtonPosition', e.index );
        this.setUserSetting( 'actionButtonPosition', Number( e.target.querySelector( 'input:checked' ).value ) );

    }

    handleAppearanceModeChange( e ) {

        // e.index is always -1 on Android! Onsen bug?
        // this.setUserSetting( 'appearanceMode', e.index );
        this.setUserSetting( 'appearanceMode', Number( e.target.querySelector( 'input:checked' ).value ) );

    }

    handleLanguageChange( e ) {

        // e.index is always -1 on Android! Onsen bug?
        // this.setUserSetting( 'language', e.index );
        this.setUserSetting( 'language', Number( e.target.querySelector( 'input:checked' ).value ) );

    }

    handleSaveUserSettings() {

        this.setState( { saving: true }, () => {

            this.props.onUpdateUserSettings( this.state.userSettings );

            /*

            // TODO reload does not work in standalone? needs check

            */
            reload();

        } );

    }

    setUserSetting( setting, value ) {

        const newState                   = { ...this.state };
        newState.userSettings[ setting ] = value;

        this.setState( newState );

    }

    render() {

        return (

            <Ons.Page className="user-settings">

                <h1 className="page-title">{_( 'Einstellungen' )}</h1>

                    <Ons.Card>

                        <div className="content">

                            <p>{_( 'Aussehen' )}</p>

                            <Ons.Segment index={Number( this.state.userSettings.appearanceMode )} onPostChange={this.handleAppearanceModeChange}>

                                <Ons.Button>{_( 'Auto' )}</Ons.Button>
                                <Ons.Button>{_( 'Hell' )}</Ons.Button>
                                <Ons.Button>{_( 'Dunkel' )}</Ons.Button>

                            </Ons.Segment>

                        </div>

                    </Ons.Card>

                    <Ons.Card>

                        <div className="content">

                            <p>{_( 'Sprache' )}</p>

                            <Ons.Segment index={this.state.userSettings.language} onPostChange={this.handleLanguageChange}>

                                {this.#languages.map( ( e, i ) => <Ons.Button key={i}>{e.label}</Ons.Button> )}

                            </Ons.Segment>

                        </div>

                    </Ons.Card>

                    <Ons.Card>

                        <div className="content">

                            <p>{_( 'Position Aktions-Button' )}</p>

                            <Ons.Segment index={getActionButtonPosition( this.state.userSettings )} onPostChange={this.handleActionButtonPositionChange}>

                                <Ons.Button>{_( 'Links' )}</Ons.Button>
                                <Ons.Button>{_( 'Mitte' )}</Ons.Button>
                                <Ons.Button>{_( 'Rechts' )}</Ons.Button>

                            </Ons.Segment>

                        </div>

                    </Ons.Card>

                <div className="buttons">

                    <div><Ons.Button onClick={this.handleSaveUserSettings} modifier="large" disabled={this.state.saving}>{_( 'Speichern' )}</Ons.Button></div>

                    <div><Ons.Button onClick={this.props.onClose} modifier="large--quiet" disabled={this.state.saving}>{_( 'Abbrechen' )}</Ons.Button></div>

                </div>

            </Ons.Page>

        );

    }

}

export default UserSettings;